export default __webpack_public_path__ + "static/media/IBMVideo.068d880c.svg";